import { Text } from "@chakra-ui/react";
import { formatTimeDuration } from "../../../utils/common/dateTime/formatTimeDuration";

import { DefaultDurationValueMap } from "../../../types/account/enum";
import { usePreference } from "../../../hooks/preference/usePreference";
import { DefaultPreferenceOptions } from "../../../constants/userPreference";

const CalendarBlockTime = () => {
  const { preference: userPreference } = usePreference();

  const duration =
    DefaultDurationValueMap[
      userPreference?.defaultDuration ?? DefaultPreferenceOptions.defaultDuration
    ];
  return (
    <Text
      color="rgba(255, 255, 255, 0.40)"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      overflow="hidden"
      noOfLines={1}
      textStyle="caption2"
    >
      {formatTimeDuration(Number(duration))}
    </Text>
  );
};

export default CalendarBlockTime;
